// Exports
export default {
	"ConferenceHistoryPage": "ConferenceHistoryPage_BT9LD",
	"privateConferenceHistoryPage": "privateConferenceHistoryPage_duMss",
	"mobileOneColLayout": "mobileOneColLayout_nK9vy",
	"stub": "stub_ip8dL",
	"desktopOneColLayout": "desktopOneColLayout_drUMe",
	"telemostDesktopIntegration": "telemostDesktopIntegration_S9TpN",
	"wrapper": "wrapper_wbT1r",
	"left": "left_Ojoiz",
	"right": "right_r1R1r"
};
